import React from 'react';

const TextBox: React.FC<{ text: string; type: string }> = props => {
  return (
    <>
      {props.type === 'title' && <h3>{props.text}</h3>}
      {props.type === 'text' && <p>{props.text}</p>}
    </>
  );
};

export default TextBox;
